import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloating from "./WhatsAppFloating";
import AssistantWidget from "./AssistantWidget";
import SiteCopyApplier from "./SiteCopyApplier";
import CopyEditMode from "./CopyEditMode";
import ListenToPage from "./ListenToPage";
import { MobileCtaBar, CookieNotice } from "./TrustBlocks";
import { LangProvider } from "../lib/i18n";

export default function Layout() {
  return (
    <LangProvider>
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <ListenToPage />
      <main id="main" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <SiteCopyApplier />
      <CopyEditMode />
      <WhatsAppFloating />
      <AssistantWidget />
      <MobileCtaBar />
      <CookieNotice />
    </div>
    </LangProvider>
  );
}
